export default __webpack_public_path__ + "static/media/tabuleiro.3b3296cc.webp";